import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TError, TErrorTranslation } from 'qp-ui-interface';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { ConfigService } from '../config/config.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

interface ErrorItem extends TError {
  description: string; // internal error description
  message: string; // localized message to show
  errorCode: string;
  type: string; // comcast Metrics.ErrorType
}

@Injectable()
export class ErrorCodeTranslationService {
  errors: TErrorTranslation | undefined;

  constructor(private configService: ConfigService, private http: HttpClient, private localStorage: LocalStorageService) {}

  public async getErrorByCode(errorCode: string, errorMessage: string): Promise<ErrorItem> {
    try {
      if (!this.errors) {
        await this.getErrorData();
      }
      const lang = this.localStorage.getItem(LocalStorageKeys.LANG) ?? 'en';
      const error = this.getError(errorCode);
      if (error) {
        return Promise.resolve({
          ...error,
          errorCode: error.errorCode,
          description: error.description,
          message: error[lang] ?? errorMessage,
          type: error.type ?? 'other',
        });
      }
      return Promise.resolve({
        message: errorMessage,
        description: errorMessage,
        errorCode,
        type: 'other',
      });
    } catch (e) {
      return {
        message: errorMessage,
        description: errorMessage,
        errorCode,
        type: 'other',
      };
    }
  }

  public async getErrorData(): Promise<void> {
    try {
      this.errors = await this.getErrorCodeTranslation();
    } catch (error: any) {
      const status = error;
      console.log(status);
      console.log('Fetch failed for errorCode.json', error);
      this.errors = undefined;
    }
    return Promise.resolve();
  }

  /**
   * Get the error code translation
   *
   * @param errorCode
   * @returns
   */
  private getError(errorCode: string): TError {
    return this.errors[errorCode];
  }

  /**
   * Get the error code translation
   *
   * @returns
   */
  private getErrorCodeTranslation(): Promise<any> {
    return this.http.get(this.configService.applicationConfig.errorCodeTranslation).toPromise();
  }
}
